import { getProp } from '@mews/fp';
import { DateTimeUtc } from '@mews/framework';

export const getAppNowUtcProp = getProp<DateTimeUtc>()('appNowUtc');
